module.exports = __webpack_public_path__ + "static/media/mo.b759f9c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mo.svg
// module id = 193
// module chunks = 0